@if (isEnabled) {
<div class="bottom-panel">
  <div class="dw-header">
    <div class="dw-title">
      <div class="dw-title__icon" style="background: var(--teal-bg)">
        <mat-icon style="color: var(--teal-dark)">credit_card</mat-icon>
      </div>
      {{'GUI.dashboard.labels.patient invoices' | translate}}
      <app-scope-chip scope="clinic"></app-scope-chip>
    </div>
    <div class="dw-header__right">
      <select
        class="dw-period-select"
        #invoicePeriodSelect
        (change)="onPeriodChange(invoicePeriodSelect.value)"
      >
        <option value="today" [selected]="billingPeriod === 'today'">
          {{'GUI.dashboard.selects.today' | translate}}
        </option>
        <option value="week" [selected]="billingPeriod === 'week'">
          {{'GUI.dashboard.selects.this week' | translate}}
        </option>
        <option value="month" [selected]="billingPeriod === 'month'">
          {{'GUI.dashboard.selects.this month' | translate}}
        </option>
      </select>
    </div>
  </div>
  <div class="invoice-list">
    @if (loading) { @for (_ of [1,2,3]; track $index) {
    <div class="skel skel--row"></div>
    } } @else { @for (inv of filteredInvoices(); track inv.id) {
    <div
      class="invoice-row"
      (click)="invoiceClicked.emit(inv)"
      (keyup.enter)="invoiceClicked.emit(inv)"
      (keyup.space)="invoiceClicked.emit(inv)"
      tabindex="0"
      role="button"
    >
      <div class="invoice-row__av">{{ inv.initials }}</div>
      <div class="invoice-row__main">
        <div class="invoice-row__name">{{ inv.name }}</div>
        <div class="invoice-row__id">
          {{ inv.id }}@if (inv.date) {
          <span class="invoice-row__date">{{ inv.date }}</span> }
        </div>
      </div>
      <div class="invoice-row__amount">{{ inv.amount }}</div>
      <span class="invoice-row__status s-paid">{{ inv.typeName }}</span>
    </div>
    } @empty {
    <span class="banner-empty"> {{'GUI.dashboard.labels.no invoices available' | translate}} </span>
    } }
  </div>
</div>
} @else {
<div class="bottom-panel">
  <div class="dw-header">
    <div class="dw-title">
      <div class="dw-title__icon" style="background: var(--teal-bg)">
        <mat-icon style="color: var(--teal-dark)">credit_card</mat-icon>
      </div>
      {{'GUI.dashboard.labels.patient invoices' | translate}}
      <app-scope-chip scope="clinic"></app-scope-chip>
    </div>
    <label class="access-toggle">
      <input
        type="checkbox"
        [checked]="isEnabled"
        (change)="toggleAccess.emit($any($event.target).checked)"
      />
      <span class="access-toggle__track"></span>
      <span class="access-toggle__thumb"></span>
    </label>
  </div>
  <div class="access-locked">
    <div class="access-locked__icon">
      <mat-icon>lock</mat-icon>
    </div>
    <div class="access-locked__text">
      Billing access is disabled.<br />Contact your administrator to enable it.
    </div>
  </div>
</div>
}
